import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogOutApi } from "../Header/services";

export const Session = () => {
  const { unix_session_time } = useSelector((state) => state.userState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let timeoutId;


  const logout = async () => {
    const logoutapi = await LogOutApi();
    if (logoutapi.status === 200) {
      localStorage.clear();
      dispatch({ type: "USER_LOGOUT" });
      navigate("/login");
      localStorage.removeItem("scanTime");
      localStorage.removeItem("scannedData");
    }
  };

  const resetLogoutTimer = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(logout, unix_session_time * 1000);
  };


  useEffect(() => {
    if (!unix_session_time) return; // Don't set timer if unix_session_time is null or undefined

    resetLogoutTimer();

    const handleActivity = () => {
      resetLogoutTimer();
    };

    document.addEventListener("mousemove", handleActivity);
    document.addEventListener("click", handleActivity);
    document.addEventListener("keydown", handleActivity);
    document.addEventListener("touchstart", handleActivity);

    return () => {
      document.removeEventListener("mousemove", handleActivity);
      document.removeEventListener("click", handleActivity);
      document.removeEventListener("keydown", handleActivity);
      document.removeEventListener("touchstart", handleActivity);
      clearTimeout(timeoutId);
      
    };
  }, []);

  return <div>{/* Your app's components go here */}</div>;
};
